export const COLOR_MODE_STORAGE_KEY = 'hf-color-mode'
export const COLOR_MODE_PREFERENCES = ['light', 'dark', 'auto']
export const DEFAULT_COLOR_MODE_PREFERENCE = 'light'

export function getSystemColorMode() {
  if (typeof window === 'undefined' || !window.matchMedia) {
    return 'light'
  }
  return window.matchMedia('(prefers-color-scheme: dark)').matches
    ? 'dark'
    : 'light'
}

export function resolveColorMode(preference) {
  if (preference === 'light' || preference === 'dark') return preference
  return getSystemColorMode()
}

export function readStoredColorMode() {
  if (typeof window === 'undefined') return DEFAULT_COLOR_MODE_PREFERENCE
  try {
    const stored = window.localStorage.getItem(COLOR_MODE_STORAGE_KEY)
    if (COLOR_MODE_PREFERENCES.includes(stored)) return stored
  } catch {
    /* ignore quota / private mode */
  }
  return DEFAULT_COLOR_MODE_PREFERENCE
}

export function writeStoredColorMode(preference) {
  if (typeof window === 'undefined') return
  if (!COLOR_MODE_PREFERENCES.includes(preference)) return
  try {
    window.localStorage.setItem(COLOR_MODE_STORAGE_KEY, preference)
  } catch {
    /* ignore */
  }
}

export function applyDocumentColorMode(resolvedMode) {
  if (typeof document === 'undefined') return
  const mode = resolvedMode === 'dark' ? 'dark' : 'light'
  document.documentElement.dataset.colorMode = mode
  document.documentElement.style.colorScheme = mode
}

export function subscribeSystemColorScheme(callback) {
  if (typeof window === 'undefined' || !window.matchMedia) {
    return () => {}
  }
  const media = window.matchMedia('(prefers-color-scheme: dark)')
  const handler = () => callback(media.matches ? 'dark' : 'light')
  if (typeof media.addEventListener === 'function') {
    media.addEventListener('change', handler)
    return () => media.removeEventListener('change', handler)
  }
  media.addListener(handler)
  return () => media.removeListener(handler)
}
